import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem("token")) {
      localStorage.removeItem("token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Uppercase without accents (Greek τόνοι removed)
export const up = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

// Category display name with accents + word "σκάφη"
export const CAT_ACCENTED = { "ΜΙΚΡΑ": "Μικρά", "ΜΕΣΑΙΑ": "Μεσαία", "ΜΕΓΑΛΑ": "Μεγάλα" };
export const catName = (s) => CAT_ACCENTED[s] || (s ? s.charAt(0) + s.slice(1).toLowerCase() : s);
export const catLabel = (s) => (s ? `${catName(s)} σκάφη` : s);

// ISO yyyy-MM-dd -> dd/MM/yyyy (ημέρα/μήνας/έτος)
export const gr = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).split("-");
  return d && m && y ? `${d}/${m}/${y}` : iso;
};

// ISO yyyy-MM-dd + 1 year (same day/month)
export const addYear = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).split("-");
  if (!y || !m || !d) return iso;
  return `${Number(y) + 1}-${m}-${d}`;
};

export const eur = (v) =>
  new Intl.NumberFormat("el-GR", { style: "currency", currency: "EUR" }).format(Number(v || 0));

export const reportUrl = (path) =>
  `${API}${path}${path.includes("?") ? "&" : "?"}token=${encodeURIComponent(localStorage.getItem("token") || "")}`;
